import React from "react";

export default function EmptyReport({ onClick }) {
  return (
    <div style={{ marginTop: "50px" }} className="text-center">
      <h4>No groups or locations selected</h4>
      <p>Get started running your report by selecting groups or locations</p>
      <div>
        <button className="btn btn-primary" onClick={onClick}>
          <span className="fa fa-plus" /> Select groups and locations
        </button>
      </div>
    </div>
  );
}
